import { atom } from 'recoil';

export const modalOpenState = atom<boolean>({
  key: 'modalOpenState',
  default: false,
});

export const stickerOpenState = atom<boolean>({
  key: 'stickerOpenState',
  default: false,
});

export const modalState = atom<{
  modalType: any;
  modalProps: any;
}>({
  key: 'modalState',
  default: { modalType: '', modalProps: '' },
});

export const registerOpenState = atom<boolean>({
  key: 'registerOpenState',
  default: false,
});
